import { App } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export function useAppToast() {
  const { message } = App.useApp();
  const { t } = useTranslation('common');

  const showSuccess = useCallback(
    (msgKey: string, defaultMsg?: string) => {
      message.success(t(msgKey, defaultMsg || 'Success'));
    },
    [message, t],
  );

  const showError = useCallback(
    (msgKey: string, defaultMsg?: string) => {
      message.error(t(msgKey, defaultMsg || 'An error occurred'));
    },
    [message, t],
  );

  const showInfo = useCallback(
    (msgKey: string, defaultMsg?: string) => {
      message.info(t(msgKey, defaultMsg || 'Info'));
    },
    [message, t],
  );

  const showWarning = useCallback(
    (msgKey: string, defaultMsg?: string) => {
      message.warning(t(msgKey, defaultMsg || 'Warning'));
    },
    [message, t],
  );

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
    message, // Expose original message object if needed
  };
}
